<template>
  <div id="page-groupSpec_group">
    <Row class="main" :gutter="16">
      <Col span="5">
        <div class="aside">
          <h5
            @click="handleSelectGroup('all')"
            class="groupList-total item-selected"
          >
          <Icon type="ios-person-add" color="orange" size="24" v-if="senderFollwoed" style="cursor: pointer;" @click="cancelFollowSender()"/>
          <Icon type="ios-person-add-outline" color="orange" size="24" style="cursor: pointer;" v-else @click="followSender()" />
          全部（{{groupNumTotal}}）</h5>
          <ul class="groupList">
            <li
              :class="'groupList-item taskId-'+item.id"
              v-for="(item, index) in groupList"
              :key="item.id"
              @click="handleSelectGroup(item.id)"
            >
            <Icon type="ios-people" color="orange" size="24" v-if="item.groupFollowed" style="cursor: pointer;" @click="cancelFollowQun(index, item.name_full)"/>
            <Icon type="ios-people-outline" color="orange" size="24" style="cursor: pointer;" v-else @click="followQun(index, item.name_full)"/>
            {{ item.name }} ({{item.num}})</li>
          </ul>
        </div>
      </Col>
      <Col span="19" id="rightSide">
        <div class="content">
          <div class="tab-content">
            <div class="listMessage-wrapper">
              <ul class="listMessage">
                <li class="listMessage-item" v-for="(item, index) in listMessage" :key="item.id">
                  <div class="ls">
                    <Tag
                      :color="item.propertyColor"
                      class="tag-property"
                      style="width:56px; line-height:23px"
                    >{{item.propertyLabel}}</Tag>
                  </div>
                  <div class="rs">
                    <div class="message-title">
                      <Icon type="ios-star" color="orange" size="24" v-if="item.followed" style="cursor: pointer;" @click="cancelFlowMeaasge(index,item.oriId)"/>
                      <Icon type="ios-star-outline" color="orange" size="24" style="cursor: pointer;" v-else @click="flowMessage(index,item.oriId)"/>
                      <span class="groupMemberName">{{item.groupMemberName}}</span>
                      <span class="groupNum">{{item.groupNum}}</span>
                      <span class="messageTime">{{item.date}} {{item.time}}</span>
                    </div>
                    <div class="message-content" v-html="item.messageContent"></div>
                    <div class="message-footer">
                      <span
                        class="checkContext"
                        :id="'checkContext-'+item.id"
                        @click="handleClickCheckContext(item.id)"
                      >查看上下文</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="page-wrapper" v-show="isShowPage">
            <Page
              :total="listMessage_total"
              :current="currentPage"
              @on-change="changePage"
              show-total
            />
          </div>
        </div>
      </Col>
    </Row>
    <!-- 模态框------------------------------------------------------------------>
    <dialog-context
      ref="dialogContext"
      :currentMsgId="currentMsgId"
      :dialogGroupName="dialogGroupName"
    ></dialog-context>
    <!-- loading动画 --------------------------------------------------------------------------->
    <loading :isLoading="isLoading"></loading>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //全部群的数量
      curSenderId: "",
      groupNumTotal: 0,
      senderFollwoed: false,
      //任务列表(dom渲染)
      groupList: [],
      //任务列表的完整数据(groupName没有省略号)
      groupList_full:[],
      //消息列表的所有数据
      listMessage: [],
      //消息列表的总数据数目
      listMessage_total: 0,
      //当前选中的消息id
      currentMsgId: "",
      //当前展示的页码
      currentPage: 1,
      //每页展示的条数(默认10条)
      pageSize: 10,
      //控制显示群对话记录的模态框
      isShowDialogGroupMessages: false,
      //群对话记录模态框群名称
      dialogGroupName: "",
      //群成员发言信息过滤条件数据
      queryData: {
        jobId: "",
        senderId: "",
        groupName: "",
        pageNum: -1,
        pageSize: 10
      },
      //是否正在加载消息列表
      isLoading: false,
      //只有第一次获取消息列表的时候需要统计所有数据数量
      flag: true,
      //如果消息数量为0，则不显示分页
      isShowPage: true
    };
  },
  created() {
    //进入页面时初始化查询数据
    this.initQueryData();
    //trigger选择<全部>
    this.handleSelectGroup("all");
  },
  methods: {

    flowMessage(index,id){
      this.$ajax({
        method: "get",
        url: "/focusOn/setFocus",
        params: {
          "id": id,
          "type": 2
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("关注成功")
          } else {
            this.$Message.error("关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
          console.log(err);
      });

      //debugger;
      if(this.listMessage[index].followed){
        this.listMessage[index].followed = false;
      }
      else{
        this.listMessage[index].followed = true;
      }
      this.$set(this.listMessage, index, this.listMessage[index])
      console.log(index,this.listMessage[index],this.listMessage[index].followed);
    },

    cancelFlowMeaasge(index,id) {
      this.$ajax({
        method: "get",
        url: "/focusOn/cancelFocus",
        params: {
          "id": id,
          "type": 2
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("取消关注成功")
          } else {
            this.$Message.error("取消关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
          console.log(err);
      });

      //debugger;
      if(this.listMessage[index].followed){
        this.listMessage[index].followed = false;
      }
      else{
        this.listMessage[index].followed = true;
      }
      this.$set(this.listMessage, index, this.listMessage[index])
      console.log(index,this.listMessage[index],this.listMessage[index].followed);
    },

    cancelFollowQun(index, id) {
      this.$ajax({
        method: "get",
         url: "/focusOn/cancelFocus",
         params: {
          "id": id,
          "type": 3
         }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("取消关注成功")
          } else {
            this.$Message.error("取消关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
        console.log(err);
      });

      if(this.groupList[index].groupFollowed){
        this.groupList[index].groupFollowed = false;
      }
      else{
        this.groupList[index].groupFollowed = true;
      }
      this.$set(this.groupList, index, this.groupList[index])
      console.log(index,this.groupList[index],this.groupList[index].groupFollowed);

    },

    followQun(index, id) {
      this.$ajax({
        method: "get",
        url: "/focusOn/setFocus",
        params: {
          "id": id,
          "type": 3
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("关注成功")
          } else {
            this.$Message.error("关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
        console.log(err);
      });

      if(this.groupList[index].groupFollowed){
        this.groupList[index].groupFollowed = false;
      }
      else{
        this.groupList[index].groupFollowed = true;
      }
      this.$set(this.groupList, index, this.groupList[index])
      console.log(index,this.groupList[index],this.groupList[index].groupFollowed);
    },

    cancelFollowSender() {
      this.$ajax({
        method: "get",
        url: "/focusOn/cancelFocus",
         params: {
          "id": this.curSenderId,
          "type": 4
         }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("取消关注成功")
          } else {
            this.$Message.error("取消关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
        console.log(err);
      })

      if(this.senderFollwoed){
        this.senderFollwoed = false;
      }
      else{
        this.senderFollwoed = true;
      }
    },

    followSender() {
      this.$ajax({
        method: "get",
        url: "/focusOn/setFocus",
        params: {
          "id": this.curSenderId,
          "type": 4
        }
      })
      .then(res => {
        if (res.data.success) {
          if (res.data.data) {
            this.$Message.success("关注成功")
          } else {
            this.$Message.error("关注失败")
          }
        }
      })
      .catch(err => {
        this.$Message.error("服务器错误");
        console.log(err);
      })
      if(this.senderFollwoed){
        this.senderFollwoed = false;
      }
      else{
        this.senderFollwoed = true;
      }
    },

    //点击<群组列表>中的群名称
    handleSelectGroup(params) {
      if (params !== "all") {
        //如果不是点击<全部>
        $(".taskId-" + params)
          .addClass("item-selected")
          .siblings("li")
          .removeClass("item-selected");
        $(".groupList-total").removeClass("item-selected");
        this.queryData.groupName = this.groupList_full.filter(item => {
          return item.id === params;
        })[0].name;
      } else {
        //如果点击了<全部>
        $(".groupList-total").addClass("item-selected");
        $(".groupList-item").removeClass("item-selected");
        this.queryData.groupName = "";
      }
      //还原页码
      this.currentPage = this.queryData.pageNum = 1;
      //获取消息列表数据
      this.getMessageListData();
    },
    //获取消息列表和群组列表的数据
    getMessageListData() {
      if (this.isLoading) return;
      this.isLoading = true;
      //发送ajax请求
      this.$ajax({
        method: "get",
        url: "./sentiment/groupMsgData/countMsgBySender",
        params: this.queryData
      })
        .then(res => {
          this.isLoading = false;
          if (res.data.success) {
            //只有第一次需要更新左边栏<全部>消息数量,以及初始化各个群发言信息
            if (this.flag) {
              this.groupNumTotal = res.data.data.jobDataSize;
              //获取各个群发言数量
              //将对象转化为数组对象
              for (let prop in res.data.data.groupDataSize) {
                let currentId = parseInt(Math.random() * 10000000);
                this.groupList.push({
                  id: currentId,
                  name: prop.length > 7 ? prop.substring(0, 7) + "..." : prop,
                  num: res.data.data.groupDataSize[prop],
                  groupFollowed: res.data.data.groupDataSizeFocus[prop],
                  name_full: prop
                });
                this.groupList_full.push({
                  id: currentId,
                  name: prop,
                  num: res.data.data.groupDataSize[prop],
                  groupFollowed: res.data.data.groupDataSizeFocus[prop]
                });
              }
              this.flag = false;
            }
            //更新所有群的发言总数
            this.listMessage_total = res.data.data.jobDataSize;

            // 更新发送人是否被关注
            this.senderFollwoed = res.data.data.senderFollwoed;

            //获取群发言消息列表
            let list = res.data.data.data;
            this.isShowPage = list.length > 0 ? true : false;
            if (list.length !== 0) {
              //先清空listMessage中的数据
              this.listMessage = [];
              for (let i = 0; i < list.length; i++) {
                this.listMessage.push({
                  id: list[i].index_id,
                  oriId: list[i].id,
                  propertyColor: list[i].feeling == "0" ? "success" : "error",
                  propertyLabel: list[i].feeling == "0" ? "非负面" : "负面",
                  feeling: list[i].feeling,
                  groupMemberName: `${list[i].sendMsgName}(${list[i].senderId})`,
                  groupMemberId: list[i].senderId,
                  groupNum: list[i].groupName,
                  followed: list[i].followed,
                  messageContent:
                    list[i].msg.length > 80
                      ? list[i].msg.substring(0, 80) + "..."
                      : list[i].msg,
                  keyWords: list[i].warning_key_words,
                  date: `${new Date(list[i].publishTime).getFullYear()}-${(
                    new Date(list[i].publishTime).getMonth() +
                    1 +
                    ""
                  ).padStart(2, "0")}-${(
                    new Date(list[i].publishTime).getDate() + ""
                  ).padStart(2, "0")}`,
                  time: `${new Date(list[i].publishTime).getHours()}:${(
                    new Date(list[i].publishTime).getMinutes() + ""
                  ).padStart(2, "0")}:${(
                    new Date(list[i].publishTime).getSeconds() + ""
                  ).padStart(2, "0")}`
                });
              }
            }
            //让左侧aside的高度与右侧高度平齐
            this.$nextTick(() => {
              let rightSideHeight = window.getComputedStyle(
                document.getElementById("rightSide")
              ).height;
              $(".aside").css({
                "min-height": rightSideHeight
              });
            });
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //切换页码
    changePage(page) {
      //更新页码
      this.currentPage = this.queryData.pageNum = page;
      //查询舆情列表数据
      this.getMessageListData();
    },
    //点击<查看上下文>按钮
    handleClickCheckContext(id) {
      //更新当前选中的消息id
      this.currentMsgId = id;
      //获取该信息数据
      let messageData = this.listMessage.filter(item => item.id === id)[0];
      //更新群名称和群号码
      this.dialogGroupName = messageData.groupNum.trim();
      //初始化模态框
      this.$refs.dialogContext.showDialog();
    },
    //初始化查询数据
    initQueryData() {
      this.curSenderId = this.$route.query.senderId;
      this.queryData.jobId = this.$route.query.jobId;
      this.queryData.senderId = this.$route.query.senderId;
      this.queryData.groupName = "";
      this.queryData.pageNum = 1;
      this.currentPage = 1;
    },
  }
};
</script>

<style lang="less">
#page-groupSpec_group {
  // 公共类----------------------------------------------------------------------//
  ul {
    list-style-type: none;
  }
  .main {
    width: 1160px;
    margin: 20px auto !important;
  }
  .option-title {
    line-height: 35px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #666666;
    letter-spacing: -0.33px;
    margin-right: 16px;
  }

  .input-search {
    float: left;
  }
  // 公共类----------------------------------------------------------------------//

  .aside {
    background-color: #fff;
    padding: 30px 0;
    min-height: 269px;
    .groupList-total {
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #333333;
      letter-spacing: -0.41px;
      text-align: left;
      padding-left: 30px;
      cursor: pointer;
      line-height: 40px;
    }
    .item-selected {
      background-color: rgb(214, 217, 247);
      color: #415af6;
    }
    .groupList {
      margin-top: 10px;
      .groupList-item {
        height: 47px;
        line-height: 47px;
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #333333;
        letter-spacing: -0.37px;
        text-align: left;
        padding-left: 30px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
      }
      .item-selected {
        background-color: rgb(214, 217, 247);
        color: #415af6;
      }
    }
  }

  .content {
    background-color: #fff;
    padding: 10px 23px 50px 23px;
    .tab-content {
      .listMessage-wrapper {
        margin-top: 20px;
        .listMessage {
          .listMessage-item {
            overflow: hidden;
            margin-bottom: 10px;
            .ls {
              float: left;
            }
            .rs {
              float: left;
              width: 790px;
              padding-left: 15px;
              .message-title {
                text-align: left;
                .groupMemberName {
                  font-family: PingFangSC-Medium;
                  font-size: 16px;
                  color: #415af6;
                  letter-spacing: 0;
                  line-height: 24px;
                }
                .groupNum {
                  font-family: PingFangSC-Medium;
                  font-size: 16px;
                  color: #415af6;
                  letter-spacing: 0;
                  line-height: 24px;
                  margin-left: 15px;
                }
                .messageTime {
                  float: right;
                  font-family: PingFangSC-Regular;
                  font-size: 14px;
                  color: #c8c7cc;
                  letter-spacing: 0;
                  line-height: 26px;
                }
              }

              .message-content {
                margin-top: 8px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                text-align: left;
                line-height: 22px;
              }
              .message-footer {
                overflow: hidden;
                height: 20px;
                .checkContext {
                  float: right;
                  font-family: PingFangSC-Regular;
                  font-size: 14px;
                  color: #415af6;
                  letter-spacing: 0;
                  line-height: 14px;
                  text-decoration: underline;
                  display: none;
                  cursor: pointer;
                }
              }
            }
          }
          .listMessage-item:hover .checkContext {
            display: block !important;
          }
        }
      }
    }
    .page-wrapper {
      margin-top: 40px;
    }
  }
}
</style>
